<template>
  <div
    v-if="form"
    class="template-high-school-report md-layout-item md-size-100 px-0"
  >
    <!--    GENERAL INFO: same layout as the other templates' detail page -->
    <div class="md-layout items-center">
      <template v-if="!embedded">
        <div class="md-layout-item md-size-100 mb-3">
          <span
            :class="getClassStatus(form.status)"
            class="bg-[#F6C3FF] p-2 rounded font-normal"
          >
            {{ generateStatusReport(form.status) }}
          </span>
        </div>

        <div class="md-layout-item md-size-33 md-small-size-100">
          <span class="font-normal">
            {{ $t("submitted_report.report_type") }}:
          </span>
          {{ generateTypeReport(formProps.report_type) }}
        </div>

        <div class="md-layout-item md-size-33 md-small-size-100">
          <span class="font-normal">
            Report template:
          </span>
          {{ formProps.report_template }}
        </div>

        <div class="md-layout-item md-size-33 md-small-size-100">
          <div v-if="isDisable || isViewOnly">
            <span class="font-normal"> {{ $t("common.term") }}: </span>
            {{ formProps.term && formProps.term.name }}
          </div>
          <md-field v-else>
            <label> {{ $t("progress_report.term") }}</label>
            <md-select
              id="term"
              v-model="termSelect.value"
              :disabled="isDisable || isViewOnly"
              name="term"
            >
              <md-option
                v-for="option in termSelect.options"
                :key="option.id + option.name"
                :value="option.id"
                >{{ $t(option.name) }}
              </md-option>
            </md-select>
          </md-field>
        </div>

        <div class="md-layout-item md-size-33 md-small-size-100">
          <div v-if="!isStudentOrFamily">
            <span class="font-normal">
              {{ $t("progress_report.the_last_inputter") }}:
            </span>
            {{ formProps.inputter && formProps.inputter.full_name }}
          </div>
        </div>

        <div class="md-layout-item md-size-33 md-small-size-100">
          <div
            v-if="
              formProps.type_sending_model !== 'No-review' && !isStudentOrFamily
            "
          >
            <span class="font-normal">
              {{ $t("progress_report.the_last_reviewer") }}:
            </span>
            {{ formProps.reviewer && formProps.reviewer.full_name }}
          </div>
        </div>
      </template>

      <div class="md-layout-item md-size-100 overflow-auto mt-3">
        <table class="table-info-student w-full">
          <tr class="table-header">
            <th><span>Student name</span></th>
            <th><span>Student ID</span></th>
            <th><span>Grade</span></th>
            <th><span>Program</span></th>
          </tr>
          <tr>
            <td>{{ formProps.student && formProps.student.full_name }}</td>
            <td>{{ formProps.student && formProps.student.student_code }}</td>
            <td>{{ formProps.student && formProps.student.grade }}</td>
            <td>{{ formProps.program && formProps.program.name }}</td>
          </tr>
        </table>
      </div>
    </div>
    <!--    GENERAL INFO-->

    <div class="report-card mt-6">
      <!-- ATTENDANCE: Live courses only -->
      <div
        v-if="
          form.school_attendance &&
            form.school_attendance.length &&
            (form.is_show_attendance || canToggleAttendanceSwitch)
        "
      >
        <div class="flex items-center justify-between">
          <p class="text-[16px] font-medium main-index">ATTENDANCE</p>
          <md-switch
            v-if="canToggleAttendanceSwitch"
            v-model="form.is_show_attendance"
            class="md-primary"
            >Show attendance in the report</md-switch
          >
        </div>
        <p v-if="!form.is_show_attendance" class="text-[#999] pb-2">
          Attendance is hidden in the report.
        </p>
        <div v-else class="overflow-auto">
          <table class="table-attendance">
            <tr class="table-header">
              <th><span>Course</span></th>
              <th><span>Total instructional days</span></th>
              <th><span>Present</span></th>
              <th><span>Excused absence</span></th>
              <th><span>Unexcused absence</span></th>
            </tr>
            <tr
              v-for="item in form.school_attendance"
              :key="'attendance' + item.class_id"
            >
              <td>{{ item.course }}</td>
              <td>
                <span class="sys-value">{{ item.number_of_session }}</span>
              </td>
              <td>
                <span class="sys-value">{{ item.days_present }}</span>
              </td>
              <td>
                <span class="sys-value">{{ item.days_excused_absence }}</span>
              </td>
              <td>
                <span class="sys-value">{{ item.days_unexcused_absence }}</span>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <!-- GRADE -->
      <p class="text-[16px] font-medium main-index pt-3">{{ gradeTitle }}</p>
      <div class="overflow-auto">
        <table class="table-grade">
          <tr class="table-header">
            <th><span>Course</span></th>
            <th>
              <span>{{ isMidTerm ? "Current" : "Final" }} grade (%)</span>
            </th>
            <th><span>Letter grade</span></th>
          </tr>
          <tr
            v-for="item in form.learning_progress"
            :key="'grade' + item.class_id"
          >
            <td>
              {{ item.subject }}
            </td>
            <td>
              <span class="sys-value">{{ item.current_score }}</span>
            </td>
            <td>
              <span class="sys-value">{{ item.scalling }}</span>
            </td>
          </tr>
        </table>
      </div>

      <!-- LEARNING PERFORMANCE: Live courses only -->
      <div v-if="liveCourses.length" class="py-2">
        <p class="text-[16px] font-medium main-index pt-3">
          LEARNING PERFORMANCE
        </p>
        <p class="pb-2">
          1: Approaching Mastery, 2: Demonstrates Mastery, 3: Exceeds Mastery
        </p>
        <div class="overflow-auto">
          <table class="table-grade">
            <tr class="table-header">
              <th><span>Course / Performance</span></th>
              <th v-for="item in behaviors" :key="'head' + item.key">
                <span>{{ item.label }}</span>
              </th>
            </tr>
            <tr v-for="course in liveCourses" :key="'score' + course.class_id">
              <td>{{ course.subject }}</td>
              <td v-for="item in behaviors" :key="item.key">
                <span v-if="isDisable || isViewOnly">{{
                  scores[course.class_id] && scores[course.class_id][item.key]
                }}</span>
                <select
                  v-else
                  v-model="scores[course.class_id][item.key]"
                  class="w-[40px]"
                >
                  <option
                    v-for="option in optionsScale"
                    :key="'option' + option"
                    :value="option"
                    >{{ option }}</option
                  >
                </select>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <!-- TEACHER COMMENTS -->
      <div class="py-2 table-teacher-comment">
        <p class="text-[16px] font-medium pb-5 main-index">TEACHER COMMENTS</p>
        <table
          v-if="visibleComments.length || showGeneralPerformance"
          class="table-comments"
        >
          <tr v-for="(item, index) in visibleComments" :key="'comment' + index">
            <td class="course">{{ item.name }}</td>
            <td class="content">
              <p v-if="isDisable || isViewOnly" class="comment-text">
                {{ item.value }}
              </p>
              <md-field v-else class="field-comment">
                <md-textarea
                  v-model="item.value"
                  :placeholder="$t('smi_sri.comment')"
                  class="max-h-[150px] min-h-[36px]"
                  md-autogrow
                ></md-textarea>
              </md-field>
            </td>
          </tr>
          <tr v-if="showGeneralPerformance">
            <td class="course">General Performance</td>
            <td class="content">
              <p v-if="isDisable || isViewOnly" class="comment-text">
                {{ form.general_performance.value }}
              </p>
              <md-field v-else class="field-comment">
                <md-textarea
                  v-model="form.general_performance.value"
                  :placeholder="$t('smi_sri.comment')"
                  class="max-h-[150px] min-h-[36px]"
                  md-autogrow
                ></md-textarea>
              </md-field>
            </td>
          </tr>
        </table>
      </div>

      <div
        v-if="!isViewOnly && !embedded"
        class="md-layout-item md-size-100 flex justify-center pb-4"
      >
        <md-button v-if="!isDisable" class="md-success mx-2" @click="saveForm"
          >{{ $t("common.save") }}
        </md-button>
        <md-button
          v-if="formProps.status !== 'Pending'"
          class="md-success mx-2"
          @click="saveAndSendEmail"
          >{{ $t(setContentSendBtn(formProps)) }}
        </md-button>
      </div>
    </div>
  </div>
  <div
    v-else
    class="md-layout-item border-l py-10 flex justify-center border-[#e5e7eb] ml-[-1px]"
  >
    <no-data-found></no-data-found>
  </div>
</template>
<script>
import {
  getClassStatus,
  setContentSendBtn,
  STATUS
} from "@/pages/ProgressReport/Components/utils";
import { service_names } from "@/constants/Services";
import { getId, Message } from "@/helpers/utils";
import cloneDeep from "lodash/cloneDeep";
import {
  generateStatusReport,
  generateTypeReport
} from "@/helpers/text-helper";
import pick from "lodash/pick";
import { hasValidRole } from "@/helpers/role-helper";
import { mapGetters } from "vuex";
import Role from "@/constants/Role";

// 1 - Approaching Mastery, 2 - Demonstrates Mastery, 3 - Exceeds Mastery
const optionsScale = [1, 2, 3];
const BEHAVIORS = [
  { key: "recall_previous_knowledge", label: "Recall Prior Knowledge" },
  { key: "understand_new_concept", label: "Understand New Concepts" },
  {
    key: "produce_language_content_output",
    label: "Language Acquisition & Response"
  },
  {
    key: "understand_and_follow_instructions",
    label: "Meet Classroom Expectations & Follow Instructions"
  },
  { key: "engagement", label: "Remain Actively Engaged during Class" }
];

export default {
  props: {
    formProps: Object,
    isViewOnly: Boolean,
    reportTemplate: String,
    // inside the reviewer modal, which brings its own approve / reject buttons
    embedded: Boolean,
    // the admin / reviewer may switch Attendance on or off while reviewing
    canToggleAttendance: Boolean
  },
  data() {
    return {
      setContentSendBtn,
      getClassStatus,
      generateStatusReport,
      generateTypeReport,
      STATUS,
      optionsScale,
      behaviors: BEHAVIORS,
      form: null,
      scores: {},
      reportType: {
        value: "",
        options: [
          { name: "submitted_report.mid_term", id: "mid_term" },
          {
            name: "submitted_report.end_of_semester_report",
            id: "end_of_semester_report"
          }
        ]
      },
      termSelect: { value: "", options: [] },
      defaultReportType: "",
      defaultTermId: "",
      defaultForm: null
    };
  },
  computed: {
    ...mapGetters("user", { useRole: "role" }),
    isDisable() {
      return (
        this.formProps?.status !== STATUS.DRAFT &&
        this.formProps?.status !== STATUS.NOT_APPROVE
      );
    },
    isStudentOrFamily() {
      return hasValidRole(this.useRole, [Role.Student, Role.Family]);
    },
    isMidTerm() {
      return this.reportType.value === "mid_term";
    },
    gradeTitle() {
      return this.isMidTerm ? "CURRENT GRADE" : "FINAL GRADE";
    },
    reportTitle() {
      return this.isMidTerm ? "MIDTERM REPORT" : "END OF SEMESTER REPORT";
    },
    // Only the admin / reviewer, while reviewing, decides whether Attendance is shown
    canToggleAttendanceSwitch() {
      return this.canToggleAttendance;
    },
    // Learning Performance and comments cover Live courses (those with a teacher) only
    liveCourses() {
      return (this.form.learning_progress || []).filter(
        course => course.is_live
      );
    },
    // Only Live courses (those with a teacher) are commented on
    visibleComments() {
      const liveClassIds = (this.form.learning_progress || [])
        .filter(course => course.is_live)
        .map(course => course.class_id);
      return (this.form.comment || []).filter(
        item =>
          liveClassIds.includes(item.class_id) &&
          (this.form.status !== STATUS.OFFICIAL || item.value)
      );
    },
    showGeneralPerformance() {
      return (
        (!this.isDisable && !this.isViewOnly) ||
        !!this.form.general_performance?.value
      );
    }
  },
  watch: {
    formProps() {
      this.initData();
    },
    "reportType.value"(newVal) {
      this.reloadTermData(newVal, this.termSelect.value);
    },
    "termSelect.value"(newVal) {
      this.reloadTermData(this.reportType.value, newVal);
    }
  },
  created() {
    this.initData();
  },
  methods: {
    // The teacher's name is the first line of the comment itself ("Teacher: Name"), so the
    // whole cell is one editable text; the separate `teacher` field is folded into it.
    normalizeComments(comments) {
      return (comments || []).map(item => {
        const value = item.value || "";
        if (!item.teacher || value.startsWith("Teacher:"))
          return { ...item, teacher: null, value };
        return {
          ...item,
          teacher: null,
          value: `Teacher: ${item.teacher}\n${value}`
        };
      });
    },
    roundingScore(score) {
      if (!score) return "";
      return (+score).toFixed(2);
    },
    initData() {
      this.termSelect.value = "";
      this.form = null;
      if (!this.formProps) return;
      this.fetchTerm();
      this.setForm(this.formProps);
    },
    setForm(form) {
      const keys = [
        "comment",
        "review_content",
        "status",
        "school_attendance",
        "learning_progress",
        "term",
        "type_sending_model",
        "title",
        "term_id",
        "report_type",
        "is_show_attendance",
        "general_performance"
      ];
      this.form = pick(form, keys);
      this.form.is_show_attendance = form.is_show_attendance !== false;
      this.form.general_performance = {
        value: "",
        ...(form.general_performance || {})
      };
      this.form.comment = this.normalizeComments(this.form.comment);
      this.form.school_attendance = Array.isArray(this.form.school_attendance)
        ? this.form.school_attendance
        : [];
      this.termSelect.value = getId(this.form.term) || "";
      this.form.reviewer_verification = form.reviewer_verification || "";
      this.reportType.value = this.form.report_type;
      this.defaultTermId = cloneDeep(getId(this.form.term) || "");
      this.defaultReportType = cloneDeep(form.report_type);
      this.defaultForm = cloneDeep(form);
      this.scores = this.mapScores(
        this.form.learning_progress,
        this.form.review_content
      );
    },
    // scores[class_id][behavior key] = 1 | 2 | 3 | ""
    mapScores(courses, reviewContent) {
      const saved = {};
      (Array.isArray(reviewContent) ? reviewContent : []).forEach(review => {
        saved[review.class_id] = {};
        (review.behaviors || []).forEach(behavior => {
          saved[review.class_id][behavior.name] = behavior.value || "";
        });
      });
      const scores = {};
      (courses || []).forEach(course => {
        scores[course.class_id] = {};
        BEHAVIORS.forEach(item => {
          scores[course.class_id][item.key] =
            (saved[course.class_id] && saved[course.class_id][item.key]) || "";
        });
      });
      return scores;
    },
    buildFormSave(reportValidate) {
      return {
        ...this.form,
        report_type: this.reportType.value,
        term_id: this.termSelect.value,
        report_validate: reportValidate,
        review_content: this.liveCourses.map(course => ({
          class_id: course.class_id,
          course: course.subject,
          teacher: course.teacher || null,
          behaviors: BEHAVIORS.map(item => ({
            name: item.key,
            value: this.scores[course.class_id][item.key] || null
          }))
        }))
      };
    },
    saveForm() {
      this.form = this.buildFormSave("not_validate_all");
      this.$emit("saveForm", { form: this.form, type: this.reportTemplate });
    },
    saveAndSendEmail() {
      this.form = this.buildFormSave("validate_all");
      if (!this.checkValidateForm()) return;
      this.$emit("saveAndSendEmail", this.form);
    },
    checkValidateForm() {
      const errors = {
        termId: !this.form.term_id && "term_required",
        reportType: this.reportType.value ? "" : "report_type_required",
        rateRequired:
          this.form.review_content.some(review =>
            review.behaviors.some(item => !item.value)
          ) && "rate_required"
      };
      Object.values(errors).forEach(item => {
        if (item) Message.error(this.$t(`progress_report.${item}`));
      });
      return Object.values(errors).every(item => !item);
    },
    reloadTermData(reportType, termId) {
      if (!reportType || !termId || !this.form) return;
      this.getClassOfTerm(
        reportType,
        termId,
        getId(this.formProps.student),
        this.formProps.program_id,
        this.$route.params.id
      );
    },
    async getClassOfTerm(reportType, termId, studentId, programId, progressId) {
      const sameAsSaved =
        this.defaultTermId === termId && this.defaultReportType === reportType;
      if (this.formProps.term_id === termId) {
        this.form.school_attendance = cloneDeep(
          this.defaultForm.school_attendance
        );
        this.form.learning_progress = cloneDeep(
          this.defaultForm.learning_progress
        );
      }
      if (sameAsSaved) {
        this.form.comment = this.normalizeComments(
          cloneDeep(this.formProps.comment)
        );
        this.scores = this.mapScores(
          this.form.learning_progress,
          this.formProps.review_content
        );
        return;
      }
      const { data } = await this.$axios.get(
        `${service_names.user}/progress/attendances`,
        {
          report_type: reportType,
          term_id: termId,
          student_id: studentId,
          program_id: programId,
          progress_id: progressId
        }
      );
      this.form.school_attendance = data.school_attendance || [];
      this.form.learning_progress = data.classes.map(item => ({
        ...item,
        current_score: this.roundingScore(item.current_score)
      }));
      this.form.comment = this.normalizeComments(
        (data.comment || []).map(item => ({ ...item, value: "" }))
      );
      this.scores = this.mapScores(this.form.learning_progress, []);
    },
    async fetchTerm() {
      const studentId = getId(this.formProps.student);
      const { data } = await this.$axios.get(
        `${service_names.school}/terms/student/${studentId}`
      );
      this.termSelect.options = data;
      this.termSelect.value = this.form?.term?.id;
    }
  }
};
</script>
<style lang="scss">
.template-high-school-report {
  --main-col-background: #891d1c;
  --main-col-student-background: #be7574;
  --main-col-text: #fff;

  .general-info {
    .md-field {
      margin: 0 !important;
      padding-left: 0 !important;
    }
  }

  .main-index {
    color: var(--main-col-background);
  }

  .table-header {
    background: var(--main-col-background);
    color: var(--main-col-text);
  }

  /* Teacher comments: course name bold dark red on the left, "Teacher: …" and the comment in
     black on the right, thin black borders - as in the approved template */
  .table-comments {
    width: 100%;
    border-collapse: collapse;

    td {
      border: 1px solid #000 !important;
      padding: 8px 10px;
      vertical-align: middle;
      height: 60px;
    }

    td.course {
      width: 22%;
      text-align: center !important;
      font-weight: bold;
      color: #980000;
    }

    td.content {
      text-align: left !important;
      color: #000;
    }

    p {
      margin: 0;
      white-space: pre-line;
    }

    .md-field {
      margin: 0 !important;
      padding-top: 0;
      min-height: 0;
    }
  }

  .table-attendance,
  .table-info-student,
  .table-grade {
    width: 100%;

    th,
    td {
      padding: 5px;
    }
  }

  .table-teacher-comment {
    .md-field {
      margin: 0 !important;
    }

    .md-table-cell {
      padding: 5px 10px !important;
    }
  }

  th,
  td {
    text-align: center !important;
    border: 1px solid #ccc;
    min-width: 30px !important;
  }

  th span {
    font-size: 14px;
    font-weight: 500;
  }

  /* Values that come from the system: bold, black and underlined. What the user fills
     in (the 1-3 choices, the comments) is not. */
  .sys-value {
    color: #000;
    font-weight: 600;
    border-bottom: 1px solid #000;
    padding: 0 8px 1px;
  }

  /* The Course column is as wide in every table, the Grade table being the reference */
  .table-attendance,
  .table-grade {
    table-layout: fixed;

    th:first-child,
    td:first-child {
      width: 32%;
    }
  }

  select {
    border-bottom: 0 !important;
    text-decoration: none;
  }
}
</style>
